import LineIcon from "pages/HomePage/components/LineIcon";
import React from "react";
import { useTranslation } from "react-i18next";

import type { SettingsNavItem, SettingsNavProps, SettingsSection } from "../settings.types";

import styles from "./SettingsNav.module.css";

const SettingsNav = ({ activeSection, items, onSelect }: SettingsNavProps) => {
	const { t } = useTranslation("settingsPage");

	const onItemClick = React.useCallback(
		(event: React.MouseEvent<HTMLButtonElement>): void => {
			onSelect(event.currentTarget.value as SettingsSection);
		},
		[onSelect]
	);

	return (
		<nav aria-label={t("title")} className={styles.nav}>
			<span className={styles.title}>{t("title")}</span>
			{items.map((item: SettingsNavItem) => {
				const isActive = item.id === activeSection;

				return (
					<button
						key={item.id}
						aria-current={isActive ? "page" : undefined}
						className={`${styles.item} ${isActive ? styles.itemActive : ""}`}
						onClick={onItemClick}
						type="button"
						value={item.id}>
						<LineIcon name={item.icon} />
						<span>{item.label}</span>
					</button>
				);
			})}
		</nav>
	);
};

export default SettingsNav;
